import type { ResponseResumeRequest, ResumeResponse } from '../types/personShow';
import { wrapFetch, wrapFetchRequiringLogin } from '../libs/fetch';

export const requestResume = async (personId: number, csrfToken: string) => {
  return await wrapFetch<ResponseResumeRequest>(`/api/v1/resumes/${personId}/request_resume`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
  });
};

export const sendResumes = async (personId: number, file: File | string, csrfToken: string) => {
  const formData = new FormData();
  formData.append('file', file);
  return await wrapFetch<ResumeResponse>(`/api/v1/resumes/${personId}`, {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': csrfToken,
    },
    body: formData,
    credentials: 'same-origin',
  });
};

export const fetchResume = async (personId: number) => {
  return await wrapFetchRequiringLogin<ResumeResponse>(`/api/v1/resumes/${personId}`);
};
